import { motion } from "framer-motion";

export default function Logo({ size = 40, animated = true }) {
  const LogoImage = (
    <img
      src="/pragma-logo.png"
      alt="Pragma Logo"
      width={size}
      height={size}
      style={{
        objectFit: "contain",
        filter: "drop-shadow(0 0 8px rgba(0, 217, 255, 0.3))"
      }}
    />
  );

  if (animated) {
    return (
      <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
      >
        {LogoImage}
      </motion.div>
    );
  }

  return LogoImage;
}

// Export SVG string for download (fallback)
export const LogoSVGString = `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="pragmaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#00d9ff" />
      <stop offset="100%" stop-color="#ff006e" />
    </linearGradient>
  </defs>
  <rect x="4" y="4" width="92" height="92" rx="8" fill="url(#pragmaGradient)" />
  <rect x="8" y="8" width="84" height="84" rx="6" fill="#0f0f0f" fill-opacity="0.3" />
  <path d="M32 25H58C67.941 25 76 33.059 76 43C76 52.941 67.941 61 58 61H46V75H32V25Z" fill="#0f0f0f" />
  <path d="M46 35V51H58C62.418 51 66 47.418 66 43C66 38.582 62.418 35 58 35H46Z" fill="url(#pragmaGradient)" />
  <circle cx="75" cy="70" r="6" fill="#00d9ff" />
</svg>`;

// Favicon version (simpler)
export const FaviconSVGString = `<svg width="32" height="32" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="pragmaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#00d9ff" />
      <stop offset="100%" stop-color="#ff006e" />
    </linearGradient>
  </defs>
  <rect x="4" y="4" width="92" height="92" rx="12" fill="url(#pragmaGradient)" />
  <path d="M32 25H58C67.941 25 76 33.059 76 43C76 52.941 67.941 61 58 61H46V75H32V25Z" fill="#0f0f0f" />
  <path d="M46 35V51H58C62.418 51 66 47.418 66 43C66 38.582 62.418 35 58 35H46Z" fill="white" />
</svg>`;
